import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AclService } from '@common-services/util/acl.service';
import { BinaryFunction, UnaryFunction } from '@dice/app/types/dice.types';

@Component({
  selector: 'table-column-checkbox',
  templateUrl: './table-column-checkbox.component.html',
  standalone: false,
})
export class TableColumnCheckboxComponent<T> implements OnChanges {
  private aclService = inject(AclService);

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  @Input() element: T;

  @Input() name?: string;

  @Input() permission?: string;

  @Input() tooltip?: string;

  @Input() cssClass?: string | string[] = [];

  @Input() onChange?: UnaryFunction<T>;

  @Input() checked?: UnaryFunction<T, boolean> = () => false;

  @Input() changed?: BinaryFunction<T, boolean>;

  static readonly sortEnabled = false;

  hasPermission: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    const { permission } = changes;
    if (!!permission && permission.firstChange) {
      this.hasPermission = this.aclService.hasPermission(this.permission);
    }
  }

  changeFn(element: T): void {
    if (this.onChange) {
      this.onChange(element);
    }
  }

  _changed(checked: boolean): void {
    if (this.changed) {
      this.changed(this.element, checked);
    }
  }
}
